import axios from 'axios'

const baseUrl = process.env.REACT_APP_BASE_URL || 'https://learnmed.ee/api';

const api = axios.create({
  baseURL: baseUrl,
  storageUrl: process.env.REACT_APP_STORAGE_URL || 'https://learnmed.ee/storage',
})

api.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem('access_token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }

  if ((config.method === 'post' || config.method === 'put') && !config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json'
  }

  config.headers['Accept'] = 'application/json'

  // For one of the developers, the ngrok browser warning was annoying
  if (window.location.hostname.includes('localhost')) {
    config.headers['ngrok-skip-browser-warning'] = '11111';
  }

  if (process.env.NODE_ENV === 'development') {
    config.httpsAgent = new AbortController(); // Workaround to avoid SSL error
  }

  return config
}, (error) => {
  return Promise.reject(error)
})

export default api
